import { service } from '../../../../helpers/http'

export const ActionIndexTermOptions = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'indexTermOptions', 
		payload: payload 
	})
}

export const ActionCreateTermOption = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'createTermOption', 
		payload: payload 
	})
}

export const ActionUpdateTermOption = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'updateTermOption', 
		payload: payload 
	})
}

export const ActionDestroyTermOption = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'term', 
		action: 'destroyTermOption', 
		payload: payload 
	})
}
